import { AsyncPipe, Location, NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ChannelModalComponent } from '../../modals/channel-modal/channel-modal.component';
import { ConfirmationModalComponent } from '../../../../../core/shared/components/modals/confirmation-modal/confirmation-modal.component';
import { Application } from '../../../../../core/shared/models/application.model';
import { GetApplicationsDetails, RotateApplicationkey } from '../../../../../core/shared/actions/application.actions';
import { ApplicationState } from '../../../../../core/shared/states/application.state';
import { DeveloperApplicationSubscriptionModalComponent } from '../../modals/developer-application-subscription-modal/developer-application-subscription-modal.component';
import { LoadingSpinnerComponent } from '../../../../../core/shared/components/loading-spinner/loading-spinner.component';
import { DeveloperApplicationSubscriptionsListComponent } from '../../lists/developer-application-subscriptions-list/developer-application-subscriptions-list.component';
import { ChannelListComponent } from '../../lists/channel-list/channel-list.component';
import { ChannelState } from '../../../../../core/shared/states/channel.state';
import { GroupAssignmentState } from '../../../../../core/shared/states/group.assignment.state';

@Component({
    selector: 'app-developer-application-details',
    templateUrl: './developer-application-details.component.html',
    styleUrls: ['./developer-application-details.component.scss'],
    standalone: true,
    imports: [
      NgClass,
      AsyncPipe,
      MatIconModule,
      MatButtonModule,
      MatTooltipModule,
      MatSnackBarModule,
      ChannelListComponent,
      DeveloperApplicationSubscriptionsListComponent,
      LoadingSpinnerComponent,
    ]
})
export class DeveloperApplicationDetailsComponent implements OnInit {
  public loading: boolean = true;
  public application!: Application;
  public applicationName: any;
  public readonly applicationdetails: Observable<Application[]>;
  public readonly channelCount: Observable<number>;
  public readonly subscriptionCount: Observable<number>;

  constructor(
    public route: ActivatedRoute,
    public store: Store,
    public modalService: NgbModal,
    public location: Location,
    private snackBar: MatSnackBar,
  ) {
    this.applicationName = this.route.snapshot.paramMap.get('Application_Name');
    this.applicationdetails = this.store.select(ApplicationState.getApplicationList);
    this.channelCount = this.store.select(ChannelState.getChannelList).pipe(map((channels) => channels.length));
    this.subscriptionCount = this.store.select(GroupAssignmentState.getGroupList).pipe(map((subscriptions) => subscriptions.length));
  }

  ngOnInit() {
    this.store.dispatch(new GetApplicationsDetails(this.applicationName));
    this.applicationdetails.subscribe((appDetails: Application[]) => {
      this.application = appDetails[0];
      setTimeout(() => { this.loading = false; }, 300);
    });
  }

  copyToClipboard(value: string, label: string): void {
    navigator.clipboard.writeText(value).then(() => {
      this.snackBar.open(`${label} copied to clipboard`, '', {
        duration: 2000,
        panelClass: 'success-snackbar',
        horizontalPosition: 'right',
        verticalPosition: 'bottom',
      });
    });
  }

  openChannelModal(applicationName: string, formMode: string, editChannel: boolean) {
    const modalRef = this.modalService.open(ChannelModalComponent, {
      size: 'lg', backdrop: 'static', keyboard: false,
    });
    modalRef.componentInstance.applicationName = applicationName;
    modalRef.componentInstance.editChannel = editChannel;
    modalRef.componentInstance.formMode = formMode;
  }

  opensubscriptionModal(applicationName: string, formMode: string, editSubscription: boolean) {
    const modalRef = this.modalService.open(DeveloperApplicationSubscriptionModalComponent, {
      size: 'lg', backdrop: 'static', keyboard: false,
    });
    modalRef.componentInstance.group = null;
    modalRef.componentInstance.applicationName = applicationName;
    modalRef.componentInstance.editSubscription = editSubscription;
    modalRef.componentInstance.formMode = formMode;
  }

  openConfirmModal(message: string) {
    const modalRef = this.modalService.open(ConfirmationModalComponent, {});
    modalRef.componentInstance.message = message;
    modalRef.result.then((event) => {
      if (event === 'confirm') {
        this.loading = true;
        this.OnRotateKey();
      }
    });
  }

  OnRotateKey(): void {
    this.store.dispatch(new RotateApplicationkey(this.application)).subscribe(
      () => { this.loading = false; window.location.reload(); },
      (error) => { console.log(error); }
    );
  }

  back(): void { this.location.back(); }
}
